import React from "react"
import SEO from "../components/seo"
import CartList from "../components/Cart/CartList"
import S from "../PageStyles/cart.module.scss"
import CartSummary from "../components/Cart/CartSummary"
import NumberCartItems from "../components/Cart/NumberCartItems"
import PrimaryButton from "../components/Buttons/PrimaryButtonLink"
import { connect } from "react-redux"
import SuggestedProducts from "../components/Skus/SuggestedProducts"

const cart = props => (
  <>
    <SEO title="Shopping Cart" />
    <section className={S.cart}>
      <h1 className={S.title}>
        My Bag (<NumberCartItems />)
      </h1>
      <section className={S.bagsummarycontainer}>
        <CartList />
        <CartSummary />
        {props.cartContainsProducts ? (
          <PrimaryButton
            link="/checkout"
            label={"PROCEED TO CHECKOUT"}
            customClassName={"buttonposition"}
          />
        ) : null}
          
      </section>
      <SuggestedProducts />
    </section>
  </>
)

const mapCartContainsProductsToProps = state => {
  return {
    cartContainsProducts: state.shoppingCart.products.length > 0,
  }
}

export default connect(mapCartContainsProductsToProps)(cart)
